import React, { useState, useEffect } from 'react';

import { DivAccordion, StyledTbody, DivAccordionMobile } from './styles';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Collapse from "@kunukn/react-collapse";
import { Switch } from 'antd';
import { Menu, MenuItem, Fade } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import { MdReorder, MdMoreVert } from 'react-icons/md';
import { FiChevronDown, FiTrash2 } from 'react-icons/fi';

import prodNoImg from '../../assets/produtos/produto_sem-imagem.svg'

export function RenderListMobile({
    prod,
    index,
    isSuperUser,
    permission,
    handleAtivo,
    controllerModalProduto,
    modalProduto,
    controllerModalApagar,
    modalApagar,
    categ,
    customError
}) {
    const [isOpen, setOpen] = useState(false);


    const excluirProd = () => {
        let prodAtivo = categ.produtos.filter( prod => prod.ativo == true)

        if (categ.ativo && prodAtivo.length == 1 && prod.ativo){
            customError('Não é possivel excluir o único produto ativo da categoria')
        } else {
            controllerModalApagar(modalApagar, false, prod.nome, prod.id);
        }
    }

    const handleProdStatus = () => {
        console.log('mobile')
        let prodAtivo = categ.produtos.filter( prod => prod.ativo == true)

        if (categ.ativo && prodAtivo.length == 1 && prod.ativo){
            customError('Não é possivel desativar o único produto ativo da categoria')
        } else {
            handleAtivo(prod.categoria_produto_id, prod.id, !prod.ativo)
        }
    }

    return (
        <>
            <Draggable
                draggableId={String(prod.id)}
                index={index}>
                {(provided, snapshot) => (
                    <DivAccordionMobile
                        isDragging={snapshot.isDragging}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        open={isOpen}>
                        <div className="header-collapse">
                            <div className="left">
                                <div className="reorder">
                                    <MdReorder
                                        className="icon-reorder" />
                                </div>

                                <div
                                    style={{ width: 48, height: 48 }}>
                                    <img
                                        style={{ width: 48, height: 48 }}
                                        className={prod.ativo ? "prod-img" : "prod-img-gray"}
                                        src={prod.imagem !== null && !!prod.imagem.length ? `https://appedidos-share-private.s3.amazonaws.com/${prod.imagem}` : prodNoImg}
                                        alt="Imagem" />


                                </div>

                                <div className="texts">
                                    <span className="title">Nome</span>
                                    <span className="content">{prod.nome}</span>
                                </div>
                            </div>

                            <div className="right">
                                <div className="icon" onClick={() => setOpen(!isOpen)}>
                                    <FiChevronDown color={"#a49b9b"} size={20} className="chevron" />
                                </div>
                            </div>
                        </div>
                        <Collapse
                            transition={'height 280ms cubic-bezier(0.4, 0, 0.2, 1)'}
                            isOpen={isOpen}>
                            <div className="collapsed-div">
                                {prod.valor_minimo ?
                                    <div className="texts" style={{ marginTop: 32, marginBottom: 32, marginLeft: 98 }}>
                                        <span className="title">Valor</span>
                                        <span className='a-partir-de'>A partir de</span>
                                        <span className="content-a-partir-de">{`R$ ${(prod.valor_minimo).replace(".", ",")}`}</span>
                                    </div>
                                    :
                                    <div
                                        className="texts"
                                        style={{ marginTop: 32, marginBottom: 32, marginLeft: 98 }}>
                                        <span className="title">Valor</span>
                                        <span className="content">{`R$ ${(prod.valor).replace(".", ",")}`}</span>
                                    </div>
                                }
                                <div
                                    style={{ marginBottom: 32, marginLeft: 98 }}
                                    className="texts-switch">
                                    <span className="title">Situação</span>
                                    <label className="switch-mobile">
                                        <Switch
                                            onChange={
                                                () => isSuperUser ?
                                                    // permission === 2 ? handleAtivo(prod.categoria_produto_id, prod.id, !prod.ativo) : null
                                                    // : handleAtivo(prod.categoria_produto_id, prod.id, !prod.ativo)
                                                    permission === 2 ? handleProdStatus() : null
                                                    : handleProdStatus()
                                            }
                                            defaultChecked={prod.ativo}
                                            checked={prod.ativo}
                                        />
                                        <h4>{prod.ativo ? 'Ativo' : 'Inativo'}</h4>
                                    </label>
                                </div>

                                <div className="buttons">
                                    <button
                                        onClick={() => controllerModalProduto(modalProduto, true, prod.id, '', null)}
                                        className="red">
                                        Ver mais
                                    </button>
                                    <button
                                        onClick={() => excluirProd()}
                                        className="white">
                                        Apagar produto
                                    </button>
                                </div>
                            </div>
                        </Collapse>
                    </DivAccordionMobile>
                )}
            </Draggable>
        </>
    )
};

export function RenderList({
    prod,
    index,
    controllerModalProduto,
    modalProduto,
    handleAtivo,
    controllerModalApagar,
    modalApagar,
    isSuperUser,
    permission,
    categ,
    customError
}) {
    const [menu, showMenu] = useState(null);
    
    const handleClick = (event) => {
        showMenu(event.currentTarget);
    };
    const handleClose = () => {
        showMenu(null);
    };

    //menu produto
    const verMais = () => {
        handleClose();
        controllerModalProduto(modalProduto, true, prod.id, '', null);
    }
    //menu produto
    const handleStatus = () => {
        handleClose();
        handleAtivo(prod.categoria_produto_id, prod.id, !prod.ativo);
    }
    //menu produto
    const excluirProd = () => {
        handleClose();
        let prodAtivo = categ.produtos.filter( prod => prod.ativo == true)

        if (categ.ativo && prodAtivo.length == 1 && prod.ativo){
            customError('Não é possivel excluir o único produto ativo da categoria')
        } else {
            controllerModalApagar(modalApagar, false, prod.nome, prod.id);
        }
    }

    //btn capsula de ativo/desativo do produto
    const handleProdStatus = () => {
        let prodAtivo = categ.produtos.filter( prod => prod.ativo == true)

        if (categ.ativo && prodAtivo.length == 1 && prod.ativo){
            customError('Não é possivel desativar o único produto ativo da categoria')
        } else {
            handleAtivo(prod.categoria_produto_id, prod.id, !prod.ativo)
        }
    }


    return (
        <Draggable
            draggableId={String(prod.id)}
            index={index}>
            {(provided, snapshot) => (
                <>
                    <StyledTbody
                        isDragging={snapshot.isDragging}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}>
                        <tr>
                            <td className="td-drag" style={{ cursor: "grab" }}>
                                <MdReorder
                                    className="icon" />
                            </td>
                            <td className="td-img">
                                <img
                                    src={prod.imagem !== null && !!prod.imagem.length ? `https://appedidos-share-private.s3.amazonaws.com/${prod.imagem}` : prodNoImg}
                                    alt="" className={prod.ativo ? "prodImg" : "prodImg-gray"} />
                            </td>
                            <td className={prod.ativo ? "td-nome" : "td-nome-gray"}><span>{prod.nome}</span></td>
                            <td className={prod.ativo ? "td-descricao" : "td-descricao-gray"} >

                            <span style= {{
                                    maxHeight: "2.8em", /* Duas linhas de altura aproximada */
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: "2", /* Número de linhas desejado */
                                    WebkitBoxOrient: "vertical",
                                    width: "198px"}}>
                                    
                                    {prod.descricao}
                            </span>
                            </td>

                            {prod.valor_minimo ?
                                <td className={prod.ativo ? "td-valor" : "td-valor-gray"}>
                                    <span className='a-partir-de'>A partir de </span> 
                                    <br/>
                                    {`R$ ${(prod.valor_minimo).replace(".", ",")}`}
                                </td>
                                :
                                <td className={prod.ativo ? "td-valor" : "td-valor-gray"}>
                                    {`R$ ${(prod.valor).replace(".", ",")}`}
                                </td>
                            }
                            <td className="td-switch">
                                <div>
                                    <label className="switch">
                                        <Switch
                                            onChange={
                                                // () => isSuperUser ?
                                                //     permission === 2 ? handleAtivo(prod.categoria_produto_id, prod.id, !prod.ativo) : null
                                                //     : handleAtivo(prod.categoria_produto_id, prod.id, !prod.ativo)
                                                () => isSuperUser ?
                                                    permission === 2 ? handleProdStatus() : null
                                                    : handleProdStatus()
                                            }
                                            defaultChecked={prod.ativo}
                                            checked={prod.ativo}
                                        />
                                        <h4>{prod.ativo ? 'Ativo' : 'Inativo'}</h4>
                                    </label>
                                    <button className="more-button" onClick={handleClick}>
                                        <MdMoreVert className="icon" />
                                    </button>
                                </div>
                            </td>
                        </tr>
                        
                    </StyledTbody>
                    <StyledMenu
                        id="simple-menu"
                        anchorEl={menu}
                        keepMounted
                        open={Boolean(menu)}
                        onClose={handleClose}
                    >
                        <StyledMenuItem onClick={verMais}>Ver mais</StyledMenuItem>
                        <StyledMenuItem onClick={handleStatus}>{prod.ativo ? "Inativar" : "Ativar"} produto</StyledMenuItem>
                        <StyledMenuItem onClick={excluirProd}>Apagar produto</StyledMenuItem>
                        <StyledMenuItem disabled onClick={null}>ID: {prod.id}</StyledMenuItem>
                    </StyledMenu>
                </>
            )}
        </Draggable>
    )
}

export function RenderCard({
    prod,
    index,
    controllerModalProduto,
    modalProduto,
    handleAtivo,
    controllerModalApagar,
    modalApagar,
    categ,
    customError
}) {
    const [menu, showMenu] = useState(null);
    const handleClick = (event) => {
        showMenu(event.currentTarget);
    };
    const handleClose = () => {
        showMenu(null);
    };
    const verMais = () => {
        handleClose();
        controllerModalProduto(modalProduto, true, prod.id, '', null);
    }
    const handleStatus = () => {
        handleClose();

        let prodAtivo = categ.produtos.filter( prod => prod.ativo == true)

        if (categ.ativo && prodAtivo.length == 1 && prod.ativo){
            customError('Não é possivel desativar o único produto ativo da categoria')
        } else {
            handleAtivo(prod.categoria_produto_id, prod.id, !prod.ativo);
        }
    }
    const excluirProd = () => {
        handleClose();
        let prodAtivo = categ.produtos.filter( prod => prod.ativo == true)

        if (categ.ativo && prodAtivo.length == 1 && prod.ativo){
            customError('Não é possivel excluir o único produto ativo da categoria')
        } else {
            controllerModalApagar(modalApagar, false, prod.nome, prod.id);
        }
    }

    return (
        <div className="card-item">
            <div className="foto">
                <img
                    className={prod.ativo ? "prod-img" : "prod-img-gray"}
                    src={prod.imagem !== null && !!prod.imagem.length ? `https://appedidos-share-private.s3.amazonaws.com/${prod.imagem}` : prodNoImg}
                    alt="" />
            </div>
            <div className="meio">
                <div className="up">
                    <span className="title">Nome</span>
                    <span className={prod.ativo ? "content" : "content-gray"}>{prod.nome}</span>
                </div>
                { prod.valor_minimo ?
                    <div className="down">
                        <span className="title">Valor</span>
                        <span className='a-partir-de'>A partir de </span>
                        <span className={prod.ativo ? "content" : "content-gray"}>{`R$ ${(prod.valor_minimo).replace(".", ",")}`}</span>
                    </div>
                    :
                    <div className="down">
                        <span className="title">Valor</span>
                        <span className={prod.ativo ? "content" : "content-gray"}>{`R$ ${(prod.valor).replace(".", ",")}`}</span>
                    </div>
                }
            </div>
            <div className="fim">
                <div className="up">
                    <span className="title">Descrição</span>
                    <span className={prod.ativo ? "content" : "content-gray"}>{prod.descricao}</span>
                </div>
                <div className="down">
                    <span className="title">Situação</span>
                    <span className={prod.ativo ? "content" : "content-gray"}>{prod.ativo ? 'Ativo' : 'Inativo'}</span>
                </div>
            </div>
            <button className="more-button" onClick={handleClick}>
                <MdMoreVert className="icon" />
            </button>
            <StyledMenu
                id="simple-menu"
                anchorEl={menu}
                keepMounted
                open={Boolean(menu)}
                onClose={handleClose}
            >
                <StyledMenuItem onClick={verMais}>Ver mais</StyledMenuItem>
                <StyledMenuItem onClick={handleStatus}>{prod.ativo ? "Inativar" : "Ativar"} produto</StyledMenuItem>
                <StyledMenuItem onClick={excluirProd}>Apagar produto</StyledMenuItem>
                <StyledMenuItem disabled onClick={null}>ID: {prod.id}</StyledMenuItem>
            </StyledMenu>
            {/* {menu && (
                <div className="menu">
                    <div className="item" onClick={() => this.controllerModalProduto(this.state.modalProduto, true, prod.id, '', null)}>
                        <span>Ver mais</span>
                    </div>
                    <div className="item" onClick={() => this.handleAtivo(prod.categoria_produto_id, prod.id, !prod.ativo)}>
                        <span>Status inativo</span>
                    </div>
                    <div className="item">
                        <span>Duplicar produto</span>
                    </div>
                    <div className="item" onClick={() => this.controllerModalApagar(this.state.modalApagar, false, prod.nome, prod.id)}>
                        <span>Excluir produto</span>
                    </div>
                    <div className="item-disabled">
                        <span>ID: {prod.id}</span>
                    </div>
                </div>
            )} */}
        </div>
    )

}

export function RenderCateg({
    categ,
    index,
    windowWidth,
    isSuperUser,
    permission,
    handleAtivoCateg,
    controllerModalApagar,
    modalApagar,
    isList,
    handleOnDragEndProd,
    controllerModalProduto,
    modalProduto,
    handleAtivo,
    categorias,
    customError
    }) {
    const [isOpen, setOpen] = useState(true);

    const apagarCateg = () =>{
        let categAtiva = categorias.filter(categ => categ.ativo == true);
      
        if (categAtiva.length === 1 && categAtiva[0].id === categ.id) {
            console.log('erro')
            customError('Não é possivel apagar a única categoria ativa')
        } else {
            controllerModalApagar(modalApagar, true, categ.nome, categ.id)
        }        
    }

    const handleCateg = () => {
        let categAtiva = categorias.filter(categ => categ.ativo == true);
        let prodAtivo = categ.produtos.filter( prod => prod.ativo == true)

        if (categAtiva.length === 1 && categAtiva[0].id === categ.id) {
            console.log('erro')
            customError('Não é possivel desativar a única categoria ativa')
        } else if (prodAtivo.length === 0 && categ.ativo) {
            handleAtivoCateg(categ.id, !categ.ativo)
        } 
        else if(prodAtivo.length === 0) {
            customError('Não é possivel ativar uma categoria sem produtos ativos')
        }
        else {
            handleAtivoCateg(categ.id, !categ.ativo)
        }    
    }

    return (
        <>
            <Draggable
                draggableId={String(categ.id)}
                index={index}>
                {(provided, snapshot) => (
                    <DivAccordion
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        ref={provided.innerRef}
                        isDragging={snapshot.isDragging}
                        open={isOpen}>
                        <div>
                            {windowWidth > 691 && (
                                <div style={{ cursor: "grab" }}>
                                    <MdReorder
                                        color={'#a49b9b'}
                                        size={16} />
                                </div>
                            )}
                            <div className="categ-name">
                                <h3 className="categoria">{categ.nome}</h3>
                            </div>
                            <div className="icon" onClick={() => setOpen(!isOpen)}>
                                <FiChevronDown color={'#000000'} size={20} className="chevron" />
                            </div>
                        </div>
                        <div>
                            <label className="switch">
                                <Switch
                                    onChange={
                                        // () => isSuperUser ?
                                        //     permission === 2 ? handleAtivoCateg(categ.id, !categ.ativo) : null
                                        //     : handleAtivoCateg(categ.id, !categ.ativo)
                                        () => isSuperUser ?
                                            permission === 2 ? handleCateg() : null
                                            : handleCateg()
                                    }
                                    defaultChecked={categ.ativo}
                                    checked={categ.ativo}
                                />
                                <h3>{categ.ativo ? 'Ativo' : 'Inativo'}</h3>
                            </label>
                            {
                                categ.produtos.length !== "" ? (
                                    <button
                                        onClick={() => apagarCateg()}
                                        className="del-button">
                                        <FiTrash2 className="icon" />
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => { }}
                                        className="del-button" style={{ cursor: "default" }}>
                                        <FiTrash2 className="icon" color="transparent" style={{ cursor: "default" }} />
                                    </button>
                                )
                            }
                        </div>
                    </DivAccordion>
                )}
            </Draggable>
            <Collapse transition={'height 280ms cubic-bezier(0.4, 0, 0.2, 1)'} isOpen={isOpen}>
                {!isList ? (
                    <div
                        className="cards-container">
                        <>
                            {!!categ.produtos.length ? (
                                categ.produtos
                                    .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                                    .map((item, index) => (
                                        <RenderCard
                                            key={item.id}
                                            prod={item}
                                            index={index}
                                            categ={categ}
                                            controllerModalProduto={(modalProduto, boolean, content, nome, id) => controllerModalProduto(modalProduto, boolean, content, nome, id)}
                                            modalProduto={modalProduto}
                                            handleAtivo={(categ_id, id, ativo) => handleAtivo(categ_id, id, ativo)}
                                            controllerModalApagar={(modalApagar, boolean, nome, id) => controllerModalApagar(modalApagar, boolean, nome, id)}
                                            modalApagar={modalApagar}
                                            customError={customError}
                                        />
                                    ))
                            ) : (
                                <h5 className="h5-inside-card">Você ainda não adicionou nenhum produto.</h5>
                            )}
                        </>
                    </div>
                ) : (
                    !!categ.produtos.length ? (
                        <>
                            <DragDropContext onDragEnd={(res) => handleOnDragEndProd(res, categ.id)}>
                                <Droppable droppableId="products">
                                    {(provided) => (
                                        windowWidth >= 900 ? (
                                            <table
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}>
                                                <thead>
                                                    <tr>
                                                        <th className="th-drag" />
                                                        <th className="th-img">Foto</th>
                                                        <th className="th-nome">Nome</th>
                                                        <th className="th-descricao">Descrição</th>
                                                        <th className="th-valor">Valor</th>
                                                        <th className="th-switch">Situação</th>
                                                    </tr>
                                                </thead>
                                                {!!categ.produtos.length && (
                                                    categ.produtos
                                                        .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                                                        .map((item, index) => (
                                                            <RenderList
                                                                key={item.id}
                                                                prod={item}
                                                                index={index}
                                                                categ={categ}
                                                                controllerModalProduto={(modalProduto, boolean, content, nome, id) => controllerModalProduto(modalProduto, boolean, content, nome, id)}
                                                                modalProduto={modalProduto}
                                                                handleAtivo={(categ_id, id, ativo) => handleAtivo(categ_id, id, ativo)}
                                                                controllerModalApagar={(modalApagar, boolean, nome, id) => controllerModalApagar(modalApagar, boolean, nome, id)}
                                                                modalApagar={modalApagar}
                                                                isSuperUser={isSuperUser}
                                                                permission={permission}
                                                                customError={customError}
                                                            />
                                                        ))
                                                )}
                                                {provided.placeholder}
                                            </table>
                                        ) : (
                                            <div {...provided.droppableProps}
                                                ref={provided.innerRef}>
                                                {!!categ.produtos.length && (
                                                    categ.produtos
                                                        .sort((a, b) => Number(a.ordem) - Number(b.ordem))
                                                        .map((item, index) => (
                                                            <RenderListMobile
                                                                key={item.id}
                                                                prod={item}
                                                                index={index}
                                                                categ={categ}
                                                                controllerModalProduto={(modalProduto, boolean, content, nome, id) => controllerModalProduto(modalProduto, boolean, content, nome, id)}
                                                                modalProduto={modalProduto}
                                                                handleAtivo={(categ_id, id, ativo) => handleAtivo(categ_id, id, ativo)}
                                                                controllerModalApagar={(modalApagar, boolean, nome, id) => controllerModalApagar(modalApagar, boolean, nome, id)}
                                                                modalApagar={modalApagar}
                                                                isSuperUser={isSuperUser}
                                                                permission={permission}
                                                                customError={customError}
                                                            />
                                                        ))
                                                )}
                                                {provided.placeholder}
                                            </div>
                                        ))}
                                </Droppable>
                            </DragDropContext>
                        </>
                    ) : (
                        <h5 className="h5-inside-map">Você ainda não adicionou nenhum produto.</h5>
                    )
                )}
                {isSuperUser ? (
                    permission === 2 ? (
                        <div className="botao">
                            <button
                                className="salvar-branco"
                                onClick={() => { controllerModalProduto(modalProduto, false, null, categ.nome, categ.id) }}>adicionar produto</button>
                        </div>
                    ) : null
                ) : (
                    <div className="botao">
                        <button
                            className="salvar-branco"
                            onClick={() => { controllerModalProduto(modalProduto, false, null, categ.nome, categ.id) }}>adicionar produto</button>
                    </div>
                )}
            </Collapse>
        </>
    )
}

const StyledMenu = withStyles({
    paper: {
        position: 'absolute',
        width: 205,
        borderRadius: 8,
        top: 76,
        margin: 0,
        padding: 0
    }
})(props => (
    <Menu
        TransitionComponent={Fade}
        elevation={24}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: "bottom", horizontal: "right"
        }}
        transformOrigin={{
            vertical: "top", horizontal: "right"
        }}
        {...props}
    />
));
const StyledMenuItem = withStyles(theme => ({
    root: {
        fontFamily: "Montserrat",
        fontSize: 16,
        color: "#7a6d6d",
        paddingLeft: 16,
        paddingTop: 16,
        paddingBottom: 16,
        margin: 0,
        "&:hover": {
            fontWeight: 500,
            color: "#3f2829",
            backgroundColor: "#faf8f8"
        }
    }
}))(MenuItem);